export default __webpack_public_path__ + "static/media/151-painted.0f2aa2c8.png";